/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getInfoCustomerPaymentApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getInfoCustomerPaymentPath);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getListBankApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListBankPath);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getListBankBranchApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getListBankBranchPath}/${payload.id}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postNewInfoCustomerPaymentApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.postNewListCustomerPaymentPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}